import { render, staticRenderFns } from "./floorCarving.vue?vue&type=template&id=0fffe7a0&scoped=true"
import script from "./floorCarving.vue?vue&type=script&lang=js"
export * from "./floorCarving.vue?vue&type=script&lang=js"
import style0 from "./floorCarving.vue?vue&type=style&index=0&id=0fffe7a0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0fffe7a0",
  null
  
)

export default component.exports